import { AsyncPipe, NgClass, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output, Renderer2, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { Layout } from '../../../api/v1/models/layout';
import { ModalSwipeDirective } from '../../directives/modal-swipe/modal-swipe.directive';
import { OverlaySwipeDirective } from '../../directives/modal-swipe/overlay-swipe.directive';
import { BottomSwipeSheetDirective } from '../../directives/modal-swipe/bottom-swipe-sheet.directive';
import { ConfigRepository } from '../../repositories/config.repository';
import { BreakpointService } from '../../services/breakpoint.service';
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  standalone: true,
    imports: [NgClass, ModalSwipeDirective, OverlaySwipeDirective, BottomSwipeSheetDirective,
        NgSwitch, NgSwitchCase, NgSwitchDefault, AsyncPipe, MatIconModule,]
})
export class ModalComponent implements OnDestroy {
  constructor(
    public breakPoint: BreakpointService,
    private renderer: Renderer2,
    private config: ConfigRepository,
  ) {}

  @ViewChild(ModalSwipeDirective) modalSwipe: ModalSwipeDirective;

  @Input() isDialog: boolean = false;
  @Input() isSmall: boolean = true;
  @Input() title?: string = '';
  @Input() additionalClass?: string;
  @Input() swipeDirection?: string = '';
  @Input() isHideHead: boolean = false;

  @Output() closeModal = new EventEmitter();

  layout$: Observable<Layout> = this.config.layout$;

  layouts = Layout;

  onClose(): void {
    this.renderer.removeClass(document.documentElement, 'is-scroll');
    if (this.swipeDirection === 'bottom') {
      this.modalSwipe.hideModal('down');
    } else {
      this.modalSwipe.hideModal('right');
    }
    this.closeModal.emit();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.documentElement, 'is-scroll');
  }
}
